import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, NgZone } from "@angular/core";
import { MatSidenavContent } from "@angular/material/sidenav";

import { fromEvent, Observable, Subject, Subscription } from "rxjs";
import { map } from "rxjs/operators";

export interface AppShellScrollEvent {
    scrollTop: number;
    clientHeight: number;
    scrollBottom: number;
    scrollHeight: number;
}

@Injectable({ providedIn: "root" })
export class AppShellScrollService {
    private subscription: Subscription;
    private scrollElement: HTMLElement | null = null;
    private readonly subject = new Subject<AppShellScrollEvent>();

    constructor(@Inject(DOCUMENT) private readonly document: Document, private readonly zone: NgZone) {
        this.init(null);
    }

    public select(): Observable<AppShellScrollEvent> {
        return this.subject.asObservable();
    }

    public hentScrollTop(): number {
        return this.scrollElement?.scrollTop ?? window.scrollY ?? 0;
    }

    public hentScrollHoejde(): number {
        return this.scrollElement?.scrollHeight ?? this.document.documentElement.scrollHeight;
    }

    public saetScrollTop(scrollTop: number): void {
        if (this.scrollElement) {
            this.scrollElement.scrollTop = scrollTop;
            return;
        }
        window.scrollTo(0, scrollTop);
    }

    public init(matSidenavContent: MatSidenavContent): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
        if (matSidenavContent) {
            this.scrollElement = matSidenavContent.getElementRef().nativeElement;
            this.subscription = matSidenavContent
                .elementScrolled()
                .pipe(
                    map(() => matSidenavContent.getElementRef().nativeElement),
                    map(element => ({
                        scrollTop: element.scrollTop,
                        clientHeight: element.clientHeight,
                        scrollBottom: element.clientHeight + element.scrollTop,
                        scrollHeight: element.scrollHeight
                    }))
                )
                .subscribe(e => this.zone.run(() => this.subject.next(e)));
        } else {
            this.scrollElement = null;
            this.subscription = fromEvent(this.document, "scroll")
                .pipe(
                    map(() => ({
                        scrollTop: window.scrollY,
                        clientHeight: window.innerHeight,
                        scrollBottom: window.innerHeight + window.scrollY,
                        scrollHeight: this.document.documentElement.scrollHeight
                    }))
                )
                .subscribe(e => this.subject.next(e));
        }
    }
}
